import { useCallback, useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const views = ['active', 'archived'];

const ActiveArchivedToggle = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const currentView = useMemo(() => {
    const requested = (searchParams.get('view') || '').toLowerCase();
    return views.includes(requested) ? requested : 'active';
  }, [searchParams]);

  const setView = useCallback((view) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('view', view);
    navigate(`${location.pathname}?${nextParams.toString()}`, { replace: true });
  }, [location.pathname, navigate, searchParams]);

  useEffect(() => {
    if (!searchParams.get('view')) {
      setView('active');
    }
  }, [searchParams, setView]);

  return (
    <div className="d-flex gap-2">
      {views.map((view) => (
        <button
          key={view}
          type="button"
          className={`btn btn-sm ${currentView === view ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => setView(view)}
        >
          {view === 'active' ? 'Active' : 'Archived'}
        </button>
      ))}
    </div>
  );
};

export default ActiveArchivedToggle;
